import { useParams } from "react-router-dom"

import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { BudgetTable } from "@costory/front/pages/Budgets/components/BudgetTable"
import { BudgetTableMode } from "@costory/front/pages/Budgets/consts"
import {
  useBudgetFormDataQuery,
  useGetBudgetQuery,
} from "@costory/front/queries/budgets"

export const BudgetEditionPage = () => {
  const { budgetId } = useParams<{ budgetId: string }>()
  const formDataQuery = useBudgetFormDataQuery()
  const budgetQuery = useGetBudgetQuery(budgetId!)

  return (
    <QueryWrapper query={budgetQuery}>
      {({ data: { versions } }) => {
        return (
          <QueryWrapper query={formDataQuery}>
            {({ data }) => (
              <BudgetTable
                formData={data}
                versionsAvailableToCompare={versions.slice(1)}
                lastVersion={versions[0]}
                mode={BudgetTableMode.Edit}
              />
            )}
          </QueryWrapper>
        )
      }}
    </QueryWrapper>
  )
}
